import React from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import Utils from "../../Utils";

import BackButton from "../../../assets/img/back.png";

import sectionsImg from "../../../assets/img/navitems/dark/sections.png";
import sectionsActiveImg from "../../../assets/img/navitems/light/sections.png";

import fieldsImg from "../../../assets/img/navitems/dark/fields.png";
import fieldsActiveImg from "../../../assets/img/navitems/light/fields.png";

import labelsImg from "../../../assets/img/navitems/dark/labels.png";
import labelsActiveImg from "../../../assets/img/navitems/light/labels.png";

import reportsImg from "../../../assets/img/navitems/dark/report.png";
import reportsActiveImg from "../../../assets/img/navitems/light/report.png";

import linksImg from "../../../assets/img/navitems/dark/links.png";
import linksActiveImg from "../../../assets/img/navitems/light/links.png";

import rangeImg from "../../../assets/img/navitems/dark/range.png";
import rangeActiveImg from "../../../assets/img/navitems/light/range.png";

const images = {
  sections: sectionsImg,
  fields: fieldsImg,
  labels: labelsImg,
  reports: reportsImg,
  links: linksImg,
  range: rangeImg
};

const activeImages = {
  sections: sectionsActiveImg,
  fields: fieldsActiveImg,
  labels: labelsActiveImg,
  reports: reportsActiveImg,
  links: linksActiveImg,
  range: rangeActiveImg
};

const ProjectLeftNavigation = () => {
  const navigate = useNavigate();
  const { siteid } = useParams();
  let isQuiz = Utils.getQuizSurveyMapValue(siteid);
  let isUpdatedView = Utils.getUpdatedViewMapValue(siteid);
  const projectPath = useParams();
  const projectId = projectPath["projectid"];

  let navLinkKeys = Utils.SITE_NAV_ITEMS_KEYS;
  let navLinkValues = JSON.parse(JSON.stringify(Utils.PROJECT_SITE_NAV_ITEMS_VALUES));

  const location = useLocation();

  const isAtRootUrl =
    location?.pathname ===
    Utils.APP_URLS.PROJECT_SITE_PAGE.replace(":projectid", projectId).replace(":siteid", siteid) ||
    location?.pathname ===
    Utils.APP_URLS.PROJECT_SITE_SECTIONS.replace(":projectid", projectId).replace(":siteid", siteid) ||
    location?.pathname.indexOf(
      Utils.APP_URLS.PROJECT_SITE_PAGE.replace(":projectid", projectId).replace(":siteid", siteid) + "/section/"
    ) === 0;

  navLinkKeys.forEach((navLink) => {
    navLinkValues[navLink].url = navLinkValues[navLink].url.replace(":projectid", projectId).replace(
      ":siteid",
      siteid
    );
  });

  const backToProjectsPage = (e) => {
    navigate(Utils.APP_URLS.PROJECTS_PAGE + `/${projectId}`);
  };

  return (
    <>
      {
        <div className="indi-left-navigation-wrapper">
          <div
            onClick={backToProjectsPage}
            className="indi-navmenu-item indi-navmenu-item-back"
          >
            <div className="indi-navmenu-inactive">
              <img
                className="indi-w-32 w-20 indi-navmenu-item-back-img"
                src={BackButton}
                alt={"Back to sites"}
              ></img>
              <span className="indi-ml-1 indi-navmenu-item-back-label">
                Back to Projects
              </span>
            </div>
          </div>

          {navLinkKeys.map((navKey, index, src) => {
            // only show links nav item if quiz & updated View are enabled at site level, from Context
            if (navKey === "links" && !isQuiz && !isUpdatedView) {
              return null;
            }

            // only show range nav item if updated View is enabled at site level, from Context
            if (navKey === "range" && !isUpdatedView) {
              return null;
            }
            return (
              <div className="indi-navmenu-item" key={index}>
                <NavLink
                  className={({ isActive }) => {
                    if (isAtRootUrl) {
                      isActive = index === 0;
                    }
                    return isActive
                      ? "indi-navmenu-active"
                      : "indi-navmenu-inactive";
                  }}
                  to={navLinkValues[navKey].url}
                >
                  {({ isActive }) => (
                    <>
                      {isActive ||
                        (isAtRootUrl && index === 0 && (isActive = true)) ? (
                        <img
                          className="indi-w-32 w-20"
                          src={activeImages[navKey]}
                          alt={navLinkValues[navKey].title}
                        ></img>
                      ) : (
                        <img
                          className="indi-w-32 w-20"
                          src={images[navKey]}
                          alt={navLinkValues[navKey].title}
                        ></img>
                      )}
                      <span className="indi-ml-1">
                        {navLinkValues[navKey].title}
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
            );
          }
          )}
        </div>
      }
    </>
  );
};

export default ProjectLeftNavigation;
